export default __webpack_public_path__ + "static/0-2152ed9f31fa837e3b1f496bfc879b9a.gif";